import React from 'react';

import { flagStyles } from '../settings';

const SvgES = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1584px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgES;
